import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import AuthStore from 'stores/AuthStore';
import PropTypes from 'prop-types';
import User from 'records/User';
import {List, Map} from 'immutable';
import UpcomingReviewsActions from 'actions/coaching/UpcomingReviewsActions';
import UpcomingReviewsStore from 'stores/coaching/UpcomingReviewsStore';
import './RepUpcomingAgenda.styl';
import UpcomingAgendaCard from 'components/dashboard/UpcomingAgendaCard';
import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';
import Loading from 'components/pure/utils/Loading';
import UPCOMING_REVIEW_ROLES from 'actions/coaching/UPCOMING_REVIEW_ROLES';

@connectToStores
export default class RepUpcomingAgenda extends React.PureComponent {
  static getStores() {
    return [UpcomingReviewsStore];
  }

  static getPropsFromStores({rep}) {
    const userStore = UserStore.getState();
    const reviewStore = UpcomingReviewsStore.getState();
    return {
      reviews: reviewStore.upcomingReviewsMap.get(rep.id, Map()).toList(),
      users: userStore.users,
      usersLoading: userStore.usersListLoading,
      reviewsLoading: reviewStore.upcomingReviewsLoading,
    };
  }

  componentDidMount() {
    const {rep} = this.props;
    UpcomingReviewsActions.upcomingReviews.defer(rep.id, UPCOMING_REVIEW_ROLES.PARTICIPANT);
  }

  componentDidUpdate({users: oldUsers = List()}, prevState, snapshot) {
    // Make sure all the coach users are loaded for all the reviews.
    const {reviews} = this.props;
    const userIds = reviews.map(r => r.coachUserId);
    if (!oldUsers.keySeq().isSuperset(userIds)) {
      UserActions.fetchAll.defer({ids: userIds});
    }
  }

  render() {
    const {reviews, rep, users, usersLoading, reviewsLoading} = this.props;
    const sessionUser = AuthStore.getState().user;
    const otherUserView = sessionUser.id !== rep.id;
    const isLoading = usersLoading || reviewsLoading;

    if (!isLoading && reviews.isEmpty()) {
      return null;
    }

    return (
      <div className="rep-upcoming-agenda">
        <h2>Upcoming Coaching Meetings</h2>
        {isLoading ? (
          <Loading />
        ) : (
          <div className="review-cards">
            {reviews.map(r => (
              <UpcomingAgendaCard
                key={r.id}
                horizontal
                repView
                coach={users.get(r.coachUserId)}
                review={r}
                sessionUser={sessionUser}
                otherUserView={otherUserView}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

RepUpcomingAgenda.propTypes = {
  rep: PropTypes.instanceOf(User).isRequired,
  reviews: PropTypes.instanceOf(List), // List<CoachingReview> (UpcomingReview ver)
};
